/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { City } from './city';
import { TimeslotSeasonTicketType } from './timeslotSeasonTicketType';

export interface SeasonTicketType { 
    id: number;
    name?: string;
    name_eng?: string;
    description?: string;
    price?: number;
    duration_hours?: number;
    freeUnlocks?: boolean;
    unlocks?: number;
    seconds: number;
    included_kms?: number;
    creation_date?: Date;
    isValid?: boolean;
    disclaimer?: string;
    isRenewAutomatic?: boolean;
    type?: SeasonTicketType.TypeEnum;
    categoryFlags: number;
    cityId?: number;
    city?: City;
    highlighted?: boolean;
    timeslots: Array<TimeslotSeasonTicketType>;
}
export namespace SeasonTicketType {
    export type TypeEnum = 'Subscription' | 'SubscriptionPacket' | 'Daily' | 'SingleRental';
    export const TypeEnum = {
        Subscription: 'Subscription' as TypeEnum,
        SubscriptionPacket: 'SubscriptionPacket' as TypeEnum,
        Daily: 'Daily' as TypeEnum,
        SingleRental: 'SingleRental' as TypeEnum
    };
}